import { __assign, __extends } from "tslib";
import '../../../common/utils/polyfills';
import React from 'react';
import { utils } from 'pro-gallery-lib';
import Gallery from './galleryContainer.js';
import '../../../versionLogger';
var ProGallery = /** @class */ (function (_super) {
    __extends(ProGallery, _super);
    function ProGallery() {
        var _this = _super.call(this) || this;
        if (utils.isLocal() && !utils.isTest()) {
            console.log('PRO GALLERY DEV');
        }
        return _this;
    }
    ProGallery.prototype.renderProps = function () {
        var _a;
        return __assign(__assign({}, this.props), { id: this.props.id, items: this.props.items || [], settings: this.props.settings || {}, offsetTop: this.props.offsetTop, proGalleryRegionLabel: this.props.proGalleryRegionLabel, isInDisplay: (_a = this.props.isInDisplay) !== null && _a !== void 0 ? _a : true });
    };
    ProGallery.prototype.containerProps = function () {
        return {
            id: "pro-gallery-".concat(this.props.id),
            className: 'pro-gallery',
        };
    };
    ProGallery.prototype.render = function () {
        return (React.createElement("div", __assign({}, this.containerProps()),
            React.createElement(Gallery, __assign({}, this.renderProps()))));
    };
    return ProGallery;
}(React.Component));
export default ProGallery;
//# sourceMappingURL=proGallery.js.map